var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"bg-window"}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v("小红书兼职报名表")]),_c('div',{staticClass:"btn-me flex-box",on:{"click":function($event){return _vm.goNext()}}},[_vm._v("开始填写")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }